import adminApi from './adminAPI';

export const adminEnqueteLegadoAPI = {
  async listar() {
    const { data } = await adminApi.get('/enquetes-legado');
    return data.enquetes;
  },

  async atualizarVisibilidade(chave, publica) {
    const { data } = await adminApi.patch(`/enquetes-legado/${chave}`, { publica });
    return data.enquete;
  }
};

export default adminEnqueteLegadoAPI;
